// Extended Diamond Chart Reports
import React, { useState, useEffect } from "react";

import DiamondReportsCutComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsCutComp";
import DiamondReportsShapeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsShapeComp";
import DiamondReportsClarityComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsClarityComp";
import DiamondReportsCertificateComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsCertificateComp";
import DiamondReportsCutGradeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsCutGradeComp";
import DiamondReportsColorComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsColorComp";
import DiamondReportsSizeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsSizeComp";
import DiamondReportsClicksComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsClicksComp";
import DiamondReportsPriceComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsPriceComp";
import ReportKpiBand from "../../ChartsGroup/DiamondReportsCharts/ReportKpiBand";
import ReportInsight from "../../ChartsGroup/DiamondReportsCharts/ReportInsight";
import ReportTabs from "../../ChartsGroup/DiamondReportsCharts/ReportTabs";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";

import { useSelector } from "react-redux";
import moment from "moment";
import { DatePicker, Select } from "antd";
import DiamondCutComp from "../../ChartsGroup/DiamondCutComp";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ExtendedDiamondChartReportsMain = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);

  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/

  /*React Binding Starts*/
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [forDealer, setForDealer] = useState("");
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [checkingMembership, setCheckingMembership] = useState(true);
  const [report, setReport] = useState(null);
  const [loadError, setLoadError] = useState(false);

  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [key, setKey] = useState(true);
  /*React Binding Ends*/

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };
  /*DatePicker Binding Ends*/

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      ReportsDiamondService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response?.data?.message;
          var responseData = response?.data?.responseData;

          let forDealer = 2;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorDiamond" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          }

          if (message === "Success") {
            if (responseData) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            setCheckingMembership(false);
            handleLoadExtendedDiamondChartReports(id, forDealer);
          } else {
            setForDealer("");
            setCheckingMembership(false);
          }
        })
        .catch((error) => {
          setForDealer("");
          setCheckingMembership(false);
        });
    } catch (error) {
      setForDealer("");
      setCheckingMembership(false);
    }
  };

  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);
      setLoadError(false);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoadChartReportsLoading(false);
          if (message === "Success" && Object.keys(responseData).length !== 0) {
            setReport(responseData);
            setKey(!key);
          } else {
            setReport(null);
            setLoadError(true);
          }
        })
        .catch((error) => {
          setLoadChartReportsLoading(false);
          setReport(null);
          setLoadError(true);
        });
    } catch (error) {
      setLoadChartReportsLoading(false);
      setReport(null);
      setLoadError(true);
    }
  };

  /*API Binding Ends*/

  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">
                  {t("Extended Diamond Chart Reports")}
                </h1>
                <div className="edr-pagehead-sub">
                  {t("Search & engagement analytics")} ·{" "}
                  {moment(globalDiamonds.dataRangeFrom).format("MMM D, YYYY")}{" "}
                  – {moment(globalDiamonds.dataRangeTo).format("MMM D, YYYY")}
                </div>
              </div>
              <button className="primary-btn" onClick={handleApplyFilter}>
                {t("Apply Filter")}
              </button>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block dataRange-input-block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Select Diamond")} </label>
                  <Select
                    className="border__grey"
                    placeholder={t("All")}
                    showSearch
                    name="SelectedDiamondValue"
                    optionFilterProp="children"
                    value={
                      globalDiamonds.SelectedDiamondValue
                        ? globalDiamonds.SelectedDiamondValue
                        : null
                    }
                    onChange={(e) =>
                      handleOnChange(e, "select", "SelectedDiamondValue")
                    }
                  >
                    <Option value="All"> {t("All")} </Option>
                    <Option value="Mined"> {t("Mined Diamond")} </Option>
                    <Option value="Lab"> {t("Lab Grown Diamond")} </Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>

          {forDealer && loadError && (
            <div className="col-md-12">
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">
                    {t("Couldn't load the report. Please try again.")}
                  </h4>
                </div>
              </div>
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportKpiBand report={report} loading={checkingMembership || LoadChartReportsLoading} />
              <ReportInsight report={report} />
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportTabs
                overview={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsShapeComp
                        data={report?.DiamondShapeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsColorComp
                        data={report?.DiamondColorSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                attributes={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsCutGradeComp
                        data={report?.DiamondCutGradeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsCertificateComp
                        data={report?.DiamondCertificateSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <DiamondCutComp
                      globalDiamonds={globalDiamonds}
                      mainForDealer={forDealer}
                      isApplyFilter={isApplyFilter}
                    />
                    <div className="col-lg-12">
                      <DiamondReportsClarityComp
                        data={report?.DiamondClaritySearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                commercial={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsPriceComp
                        data={report?.DiamondPrice}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsSizeComp
                        data={report?.DiamondSizeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                trend={
                  <div className="col-lg-12">
                    <DiamondReportsClicksComp
                      globalDiamonds={globalDiamonds}
                      mainForDealer={forDealer}
                      isApplyFilter={isApplyFilter}
                    />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExtendedDiamondChartReportsMain;
